import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_KEYCONTACTS_LOAD,
    ACTION_KEYCONTACTS_LOAD_BY_ID,

    ACTION_KEYCONTACTS_SAVE,

    ACTION_KEYCONTACTS_CREATE,

    ACTION_KEYCONTACTS_VALIDATE,

    IKeyContactLoadAction,
    IKeyContactLoadByIdAction,
    IKeyContactLoadFailureAction,
    IKeyContactLoadSuccessAction,

    IKeyContactSaveAction,
    IKeyContactSaveSuccessAction,
    IKeyContactSaveFailureAction,

    IKeyContactCreateAction,
    IKeyContactCreateSuccessAction,
    IKeyContactCreateFailureAction,

    IKeyContactValidateAction,
    IKeyContactValidateSuccessAction,
    IKeyContactValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/keyContacts";
import { keycontactsApi } from "../services/keyContact";


export const
    getKeyContactsEpic = (action$): Observable<IKeyContactLoadSuccessAction | IKeyContactLoadFailureAction> => {
        return action$
            .ofType(ACTION_KEYCONTACTS_LOAD)
            .mergeMap((_action: IKeyContactLoadAction) => {
                return keycontactsApi
                    .getKeyContacts()
                    .map(response =>
                        LoadSuccess(response.keyContacts, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getKeyContactByIdEpic = (action$): Observable<IKeyContactLoadSuccessAction | IKeyContactLoadFailureAction> => {
        return action$
            .ofType(ACTION_KEYCONTACTS_LOAD_BY_ID)
            .mergeMap((action: IKeyContactLoadByIdAction) => {
                return keycontactsApi
                    .getKeyContactById(action.id)
                    .map(response =>
                        LoadSuccess(response.keyContact, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setKeyContactEpic = (action$): Observable<IKeyContactSaveSuccessAction | IKeyContactSaveFailureAction> => {
        return action$
            .ofType(ACTION_KEYCONTACTS_SAVE)
            .mergeMap((action: IKeyContactSaveAction) => {
                return keycontactsApi
                    .setKeyContact(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.keyContact, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createKeyContactEpic = (action$): Observable<IKeyContactCreateSuccessAction | IKeyContactCreateFailureAction> => {
        return action$
            .ofType(ACTION_KEYCONTACTS_CREATE)
            .mergeMap((_action: IKeyContactCreateAction) => {
                return keycontactsApi
                    .createKeyContact()
                    .map(response =>
                        CreateSuccess(
                            response.keyContact,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateKeyContactEpic = (action$): Observable<IKeyContactValidateSuccessAction | IKeyContactValidateFailureAction> => {
        return action$
            .ofType(ACTION_KEYCONTACTS_VALIDATE)
            .mergeMap((action: IKeyContactValidateAction) => {
                return keycontactsApi
                    .validateKeyContact(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.keyContact, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



